import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HowSellComponent } from './how-sell.component';
import { FormsModule } from '@angular/forms';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';



@NgModule({
  declarations: [
    HowSellComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    PipesModule
  ], exports: [
    HowSellComponent
  ]
})
export class HowSellModule { }
